import { connect } from 'react-redux';
import ConfirmDeleteModal from './shared/confirm_delete_modal.jsx';

import {
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

import {
  deleteMenuItem
} from 'zoomforth_codesbane_editor/action_creators/navigation.js';

import {
  closeMenuItemEditor
} from 'zoomforth_codesbane_editor/action_creators/navigation.js';

import {
  getMenuItemDisplayName 
} from 'zoomforth_codesbane_viewer/lib/navigation.js';

const mapStateToProps = (state, { menuItem }) => {
  return {
    title: 'Really delete link?',
    body: `You are about to delete this ${getMenuItemDisplayName(menuItem)} Link. This cannot be undone.`,
    confirmText: 'Delete Link',
    cancelText: 'Cancel'
  };
};


const mapDispatchToProps = (dispatch, { menuItem }) => (
  {
    onCancel: ()=> { 
      dispatch(closeModal()); 
    },
    onConfirm: ()=> { 
      dispatch(deleteMenuItem(menuItem));
      dispatch(closeMenuItemEditor());
      dispatch(closeModal());
    }
  }
);

const ConfirmDeleteMenuItemModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmDeleteModal);

ConfirmDeleteMenuItemModal.editorModalName = 'ConfirmDeleteMenuItemModal';

export default ConfirmDeleteMenuItemModal;
